@if (loggedInUser(); as user) {
    <!-- 5px over 6px keeps the avatar on a whole pixel in the 55px bar, so its letters sit centred. -->
    <button
        type="button"
        class="profile-menu-trigger flex items-center gap-2.5 rounded-xl border border-[var(--topbar-section-border)] px-2 pb-[6px] pt-[5px] transition-all duration-200 hover:bg-[var(--topbar-section-hover)]"
        [attr.aria-expanded]="menu.overlayVisible()"
        aria-haspopup="menu"
        aria-label="Open the account menu"
        data-testid="profile-menu-button"
        (click)="menu.toggle($event)"
    >
        <span class="relative flex shrink-0">
            <app-avatar class="h-[30px] w-[30px] rounded-lg! text-sm" [person]="user.person" />
            <span
                class="absolute -bottom-0.5 -right-0.5 h-[10px] w-[10px] rounded-full border-2 border-[var(--topbar-background)] bg-green-500"
                aria-hidden="true"
            ></span>
        </span>
        <span class="hidden flex-col items-start sm:flex">
            <span
                class="text-[13px] leading-none font-semibold text-[var(--topbar-text)]"
                data-testid="topbar-person-name"
            >
                {{ displayName() }}
            </span>
            @if (roleLabel(); as role) {
                <span
                    class="mt-[3px] text-[12px] leading-none text-[var(--topbar-text-muted)]"
                    data-testid="topbar-person-role"
                >
                    {{ role }}
                </span>
            }
        </span>
        <i
            class="pi pi-angle-down text-[18px]! text-[var(--topbar-text-muted)] transition-transform duration-300"
            [class.rotate-180]="menu.overlayVisible()"
            aria-hidden="true"
        ></i>
    </button>

    <p-popover #menu styleClass="layout-topbar-popover">
        <div class="w-60" role="menu">
            <div class="flex items-center gap-3 border-b border-[var(--border-default)] px-3 pb-3">
                <app-avatar class="h-10 w-10 rounded-lg! text-sm" [person]="user.person" />
                <div class="min-w-0">
                    <p class="truncate text-sm font-semibold text-[var(--text-primary)]">
                        {{ displayName() }}
                    </p>
                    <p class="truncate text-xs text-[var(--text-color-secondary)]">
                        {{ user.person.email }}
                    </p>
                </div>
            </div>
            <button
                type="button"
                role="menuitem"
                class="mt-1 flex w-full items-center gap-2 rounded-md px-3 py-2 text-left text-sm text-[var(--text-color)] hover:bg-[var(--surface-hover)]"
                data-testid="profile-menu-logout"
                (click)="menu.hide(); logout()"
            >
                <i class="pi pi-sign-out text-sm" aria-hidden="true"></i>
                Logout
            </button>
        </div>
    </p-popover>
}
